import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// This page redirects to the admin panel with the bot-detection tab
const AdminDashboardPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/admin?tab=bot-detection', { replace: true });
  }, [navigate]);
  return null;
};

export default AdminDashboardPage;
